module.exports = __webpack_public_path__ + "img/deals.276fc924.svg";